import classnames from "classnames/bind";
import { useTranslation } from "react-i18next";

import { AppDownloadQRCode } from "@/components/gift-cards/app-download-qr-code/app-download-qr-code";

import { useIsArcade } from "@/hooks/useIsArcade";

import { Locale } from "@/types/locale";

import LinkButton from "../../buttons/link-button";
import styles from "./gift-card-download-details.module.scss";

const cx = classnames.bind(styles);

export type Props = {
    locale: Locale;
};

export const GiftCardDownloadDetails: React.FC<Props> = ({ locale }) => {
    const { t } = useTranslation();
    const isArcade = useIsArcade();
    const localeToGiftCardLink = {
        "en-US": "https://afterpayus.app.link/WebUS-BAU-Giftcard-indivlandingpage",
        "en-AU": "https://afterpayau.app.link/WebAU-BAU-Giftcard-indivlandingpage",
        "en-NZ": "https://afterpayau.app.link/WebNZ-BAU-Giftcard-indivlandingpage",
        "en-GB": "https://clearpay.app.link/WebUK-BAU-Giftcard-herolandingpage",
        "en-CA": "https://afterpayus.app.link/bLSxpLhGMKb",
        "fr-CA": "https://afterpayus.app.link/bLSxpLhGMKb",
    };

    const paragraphClassName = cx({
        [styles.paragraph]: !isArcade,
        [styles.paragraphArcade]: isArcade,
    });

    return (
        <div className={styles.container}>
            {isArcade ? (
                <h2 className={styles.heading}>{t("giftCards.details.heading")}</h2>
            ) : (
                <h1 className={styles.heading}>{t("giftCards.details.heading")}</h1>
            )}
            <p className={paragraphClassName}>{t("giftCards.details.content")}</p>

            {localeToGiftCardLink[locale] && (
                <>
                    <div className={styles.appLinkContainer}>
                        <LinkButton
                            kind="black"
                            label={t("giftCards.details.buttonLabel")}
                            size="large"
                            url={localeToGiftCardLink[locale]}
                        />
                    </div>
                    <div className={styles.qrCodeContainer}>
                        <AppDownloadQRCode locale={locale} />
                        <p className={styles.qrCodeText}>{t("giftCards.details.codeLabel")}</p>
                    </div>
                </>
            )}
        </div>
    );
};
